import React, { useState } from 'react';
import { profileApi } from '../../../services/api';
import AddEditModal from '../shared/AddEditModal';
import ItemCard from '../shared/ItemCard';

const educationFields = [
    { name: 'institution', label: 'المؤسسة التعليمية', type: 'text', required: true, placeholder: 'اسم الجامعة' },
    { name: 'degree_type', label: 'نوع الشهادة', type: 'select', options: [
        { value: 'High School', label: 'ثانوية' },
        { value: 'Associate', label: 'دبلوم' },
        { value: 'Bachelor', label: 'بكالوريوس' },
        { value: 'Master', label: 'ماجستير' },
        { value: 'PhD', label: 'دكتوراه' },
        { value: 'Certificate', label: 'شهادة' },
        { value: 'Diploma', label: 'دبلوم عالي' }
    ]},
    { name: 'field_of_study', label: 'التخصص', type: 'text', placeholder: 'علوم الحاسب' },
    { name: 'location', label: 'الموقع', type: 'text', placeholder: 'المدينة، الدولة' },
    { name: 'start_date', label: 'تاريخ البداية', type: 'month', placeholder: '2019-09' },
    { name: 'graduation_date', label: 'تاريخ التخرج', type: 'month', placeholder: '2023-06' },
    { name: 'gpa', label: 'المعدل', type: 'text', placeholder: '4.5/5.0' },
    { name: 'honors', label: 'مراتب الشرف والجوائز', type: 'list', placeholder: 'أضف مرتبة شرف...' },
    { name: 'relevant_coursework', label: 'المقررات ذات الصلة', type: 'tags', placeholder: 'أضف مقرر...' },
    { name: 'importance', label: 'الأهمية', type: 'importance' }
];

export default function Education({ profile, onRefresh }) {
    const [showModal, setShowModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [loading, setLoading] = useState(false);

    const educationList = profile?.education || [];

    const handleAdd = () => {
        setEditItem(null);
        setShowModal(true);
    };

    const handleEdit = (item) => {
        setEditItem(item);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('هل أنت متأكد من حذف هذا التعليم؟')) return;
        setLoading(true);
        try {
            await profileApi.deleteEducation(id);
            onRefresh('education');
        } catch (err) {
            alert('فشل في حذف التعليم');
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (data) => {
        setLoading(true);
        try {
            if (editItem) {
                await profileApi.updateEducation(editItem.id, data);
            } else {
                await profileApi.addEducation(data);
            }
            setShowModal(false);
            onRefresh('education');
        } catch (err) {
            alert('فشل في حفظ التعليم');
        } finally {
            setLoading(false);
        }
    };

    const renderCard = (edu) => (
        <ItemCard
            key={edu.id}
            title={`${edu.degree_type || ''} ${edu.field_of_study ? `في ${edu.field_of_study}` : ''}`.trim() || 'تعليم'}
            subtitle={`${edu.institution}${edu.location ? ` • ${edu.location}` : ''}`}
            meta={[
                edu.graduation_date && `التخرج: ${edu.graduation_date}`,
                edu.gpa && `المعدل: ${edu.gpa}`
            ].filter(Boolean)}
            tags={edu.relevant_coursework}
            importance={edu.importance}
            highlights={edu.honors}
            onEdit={() => handleEdit(edu)}
            onDelete={() => handleDelete(edu.id)}
        />
    );

    return (
        <div className="section-container">
            <div className="section-header">
                <h2 className="section-title">التعليم</h2>
                <button className="add-button" onClick={handleAdd}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    إضافة تعليم
                </button>
            </div>

            {educationList.length === 0 ? (
                <div className="empty-state">
                    <div className="empty-state-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
                            <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
                        </svg>
                    </div>
                    <h3 className="empty-state-title">لا يوجد تعليم بعد</h3>
                    <p className="empty-state-description">أضف خلفيتك التعليمية</p>
                    <button className="add-button" onClick={handleAdd}>أضف تعليمك الأول</button>
                </div>
            ) : (
                <div className="items-grid">
                    {educationList.map(renderCard)}
                </div>
            )}

            {showModal && (
                <AddEditModal
                    title={editItem ? 'تعديل التعليم' : 'إضافة تعليم'}
                    fields={educationFields}
                    initialData={editItem || {}}
                    onSave={handleSave}
                    onClose={() => setShowModal(false)}
                    loading={loading}
                />
            )}
        </div>
    );
}
